module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fc-Gd-Hc 后背.cea1bad4.png";